//
//
//

import WxService from "@/api/wxService";
import UserService from "@/api/userService";
import SysUtils from "@/utils/sysUtils";
import { setToken, setUserInfo } from "@/utils/auth";

/**
 * 微信授权页面
 * 进入到这里，说明缓存中没有网页授权access_token，调接口获取授权链接，拿到code，然后通过code获取到access_token
 * 授权成功后，重新回到这个页面，判断路径中有没有code，根据code获取access token并将access token缓存，成功后跳转到登录页
 */
export default {
  data() {
    return {};
  },
  mounted() {
    // 如果路径中有code，说明已经被微信授权过了，通过code拿到access_token后跳转到登录页
    if (window.location.search.indexOf("code") != -1) {
      let oauthCode = SysUtils.getUrlKey("code");
      // 如果路径包含场景值scene并且为quit，说明是从退出操作过来，直接进入登录页
      if (this.$route.query.scene == "quit") {
        this.$router.push({
          path: "/login",
        });
      } else {
        UserService.wxLogin(oauthCode)
          .then((res) => {
            setUserInfo(res.data);
            setToken(res.data.accessToken); // 缓存accessToken
            let data = res.data;

            SysUtils.setThemeType(data.starLevel, this); // 设置主题

            if (data.phoneStatus != 1) {
              // 如果该用户没有绑定手机号，跳转到login页，手动登录
              this.$router.push({
                path: "/login",
              });
            } else {
              if (data.logisticsContractStatus != 1 || data.purchaseContractStatus != 1 || data.idCardStatus != 1) {
                this.$router.push({
                  path: "/remind",
                  query: {
                    memberId: data.memberId,
                    companyId: data.companyId,
                  },
                });
              } else {
                this.$router.push({
                  path: "/robbing",
                });
              }
            }
          })
          .catch((err) => {
            this.$vux.toast.text(err.msg);
          });
      }
    } else {
      let url = window.location.href; // 重定向页面路径，这里授权成功后跳转到授权页
      WxService.wxAuth(url);
    }
  },
};



// WEBPACK FOOTER //
// ./src/views/wxAuth.vue